import { Box, ButtonV2, TextV2, styled } from '@withjoy/joykit';

export const StyledProductTileText = styled(TextV2)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const StyledProductCtaContainer = styled(Box)``;

export const StyledViewProductCta = styled(ButtonV2)``;
